import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, ChefHat } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
    const [pwd, setPwd] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/admin/login", { password: pwd });
            sessionStorage.setItem("pizano_admin", "1");
            navigate("/admin/dashboard");
        } catch (err) {
            toast.error("Wrong password");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="min-h-screen bg-pz-bg paper-grain grid place-items-center px-6"
            data-testid="admin-login"
        >
            <div className="max-w-md w-full">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-pz-text hover:text-pz-primary mb-6 text-sm"
                >
                    <ArrowLeft size={16} /> Back
                </Link>
                <div className="bg-white rounded-2xl border border-pz-border p-7 shadow-sm">
                    <div className="w-12 h-12 rounded-full bg-pz-text text-white grid place-items-center mb-5">
                        <ShieldCheck size={22} />
                    </div>
                    <h1 className="font-display text-3xl text-pz-text mb-1">
                        Admin Access
                    </h1>
                    <p className="text-sm text-pz-textMuted mb-6">
                        Enter the password to manage orders
                    </p>
                    <form onSubmit={handleLogin} className="space-y-4">
                        <div>
                            <Label className="text-pz-text">Password</Label>
                            <Input
                                type="password"
                                value={pwd}
                                onChange={(e) => setPwd(e.target.value)}
                                placeholder="••••••"
                                data-testid="admin-password-input"
                                className="mt-1.5 rounded-xl border-pz-border focus-visible:ring-pz-primary"
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={loading}
                            data-testid="admin-login-btn"
                            className="w-full h-11 rounded-full bg-pz-primary hover:bg-pz-primaryHover text-white uppercase tracking-wider text-sm font-bold"
                        >
                            {loading ? "..." : "Sign In"}
                        </Button>
                    </form>
                </div>
                <div className="mt-6 flex items-center justify-center gap-2 text-pz-textMuted text-xs">
                    <ChefHat size={14} className="text-pz-primary" />
                    Pizano Italiano · Staff only
                </div>
            </div>
        </div>
    );
}
